module.exports = __webpack_public_path__ + "static/media/boy-2.41763d14.png";